<template>
  <section class="kws-quiz-outro" v-bind="parseAttributeString">
    <div class="kws-quiz-text-wrapper">
      <h2 class="h2">{{ headline }}</h2>
      <first-spirit-image
        v-if="img && img.sm"
        class="kws-quiz-img-mobile"
        :fs-cc-attrs="img.fsCcAttrs"
        :alt="img.alt"
        :src="img.sm.src"
        :srcset="img.sm.srcset"
        :sizes="img.sm.sizes"
      ></first-spirit-image>
      <div class="kws-quiz-text-content">
        <p class="">{{ text }}</p>
        <a v-if="link" :href="link.href" v-text="link.description" :target="link.target"
           class="button button--medium button--primary"/>
      </div>
    </div>
    <div class="kws-quiz-img-desktop">
      <first-spirit-image
        v-if="img && img.lg"
        class="kws-quiz-img-desktop"
        :fs-cc-attrs="img.fsCcAttrs"
        :alt="img.alt"
        :src="img.lg.src"
        :srcset="img.lg.srcset"
        :sizes="img.lg.sizes"
      ></first-spirit-image>
    </div>
  </section>
</template>

<script>
import FirstSpiritContentCreatorMixin from '../../shared/mixins/FirstSpiritContentCreatorMixin';
import FirstSpiritImage from './fs-image.vue';

export default {
  props: {
    headline: String,
    text: String,
    img: Object,
    link: Object,
  },
  components: {
    FirstSpiritImage,
  },
  mixins: [FirstSpiritContentCreatorMixin],
};
</script>

<style scoped lang="scss">
.kws-quiz-outro {
  background-color: rgba(255, 255, 255, .75);
  color: $color-black;

  p {
    font-size: rem(15px);
    line-height: rem(18px);
  }
}
</style>
